"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KegTossAbilityHandler = exports.KegTossActorAbilityFactory = exports.KegTossAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class KegTossAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.KegToss;
        this.__typeName = "KegToss";
    }
}
exports.KegTossAbilityArgs = KegTossAbilityArgs;
let KegTossActorAbilityFactory = class KegTossActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("KegToss", "AllEnemies", 2);
    }
};
KegTossActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("KegToss")
], KegTossActorAbilityFactory);
exports.KegTossActorAbilityFactory = KegTossActorAbilityFactory;
let KegTossAbilityHandler = class KegTossAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
            .forEach(enemy => {
            container.applyProjectileAttackWithDamage({
                sequence: sequence.pushSequence("sequential"),
                abilityKey: ability.args.__typeName,
                attackType: "magic",
                attackerId: ability.invokerId,
                targetId: enemy,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Physical", 40)
                ],
                projectileType: "Keg",
                projectilePath: "line",
                onHit(sequence) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: enemy,
                        duration: Duration_1.Duration.Turns(4),
                        effect: new core_1.DarknessEffectArgs(),
                    });
                }
            });
        });
    }
};
KegTossAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.KegToss)
], KegTossAbilityHandler);
exports.KegTossAbilityHandler = KegTossAbilityHandler;
